import LearnAcademyPanelCoursesSkeleton from "./LearnAcademyPanelCoursesSkeleton";
import LearnAcademyPanelHeaderSkeleton from "./LearnAcademyPanelHeaderSkeleton";
import LearnAcademyPanelSkillpathsSkeleton from "./LearnAcademyPanelSkillpathsSkeleton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LearnAcademyPanelSkeleton = function LearnAcademyPanelSkeleton(_ref) {
  var isDark = _ref.isDark;
  var innerBackgroundColor = isDark ? 'bg-base-lighter-dark-mode' : 'bg-gray-main';
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full",
    children: [/*#__PURE__*/_jsx(LearnAcademyPanelHeaderSkeleton, {
      isDark: isDark,
      innerBackgroundColor: innerBackgroundColor,
      className: "mb-16"
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex",
      children: [/*#__PURE__*/_jsx(LearnAcademyPanelSkillpathsSkeleton, {
        isDark: isDark,
        innerBackgroundColor: innerBackgroundColor,
        className: "mr-16"
      }), /*#__PURE__*/_jsx(LearnAcademyPanelCoursesSkeleton, {
        isDark: isDark,
        innerBackgroundColor: innerBackgroundColor
      })]
    })]
  });
};
export default LearnAcademyPanelSkeleton;